<template>
  <div class="modal-content">
    <div class="box-detail-investment">
      <div class="row">
        <div class="column column-20 -hidden-xs">
          <div class="box-company-logo">
            <img :src="investmentDetail.business_logo"
              onerror="this.src='https://placeimg.com/100/100/tech'"
              class="logo">
          </div>
        </div>
        <div class="column">
          <h3 class="detailtitle">Solicitud:</h3>
          <p>
            <strong class="name">ID solicitud</strong>:
            {{ investmentDetail.funding_request_id }}
          </p>
          <p>
            <strong class="name">Estado</strong>:
            <span class="state pill"
              :class="investmentDetail.funding_request_state">
              {{ investmentDetail.funding_state }}
            </span>
          </p>
          <p>
            <strong class="name">Fecha de activación</strong>:
            <span v-if="investmentDetail.activation_date !== null">
              {{ format(investmentDetail.activation_date, 'DD/MM/YYYY') }}
            </span>
            <span v-else>-</span>
          </p>
          <p>
            <strong class="name">Tipo de producto</strong>:
            {{ investmentDetail.product_type }}
          </p>
          <p>
            <strong class="name">Plazo</strong>:
            {{ investmentDetail.duration }} días
          </p>
          <p>
            <strong class="name">Tasa</strong>:
            {{ formatPercentage(investmentDetail.rate) }}
          </p>
        </div>
        <div class="column">
          <h3 class="detailtitle">Inversión:</h3>
          <p>
            <strong class="name">ID inversión</strong>:
            {{ investmentDetail.id }}
          </p>
          <p>
            <strong class="name">Estado</strong>:
            <span class="state pill"
              :class="investmentDetail.investment_state">
              {{ investmentDetail.investment_state }}
            </span>
          </p>
          <p>
            <strong class="name">Fecha de aprobación</strong>:
            <span v-if="investmentDetail.approved_date !== null">
              {{ format(investmentDetail.approved_date, 'DD/MM/YYYY') }}
            </span>
            <span v-else>-</span>
          </p>
          <p>
            <strong class="name">Monto inversión</strong>:
            {{ formatCurrency(investmentDetail.amount) }}
          </p>
          <p
            v-if="investmentDetail.investment_state === 'Activa' &&
              investmentDetail.recovered_capital !== '0.00'">
            <strong class="name">Capital recuperado</strong>:
            {{ formatCurrency(investmentDetail.recovered_capital) }}
          </p>
          <p>
            <strong class="name">Comisión Cumplo</strong>: $0
          </p>
          <p>
            <strong class="name">*Comisión estimada</strong>:
            {{ formatCurrency(investmentDetail.collection_fee) }}
          </p>
        </div>
      </div>
      <br>
      <div class="row">
        <p>
          <small>
            <b>*Recuerda que este es un monto aproximado de tu cobro,
              el monto real se verá reflejado cuando se haya liquidado el ID.
            </b>
          </small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import mixins from '@/mixins/index'

export default {
  name: 'EnterpriseDetails',
  mixins: [mixins],
  props: {
    investmentDetail: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      format
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboardInvestment/EnterpriseDetails.vue